// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eg-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  width: min(100%, 300px);
}

.eg-card {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: var(--eg-bg, #fff);
  border: 1px solid var(--eg-border, #e2e8f0);
  border-radius: 14px;
  padding: 10px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.eg-card[role='link'] {
  cursor: pointer;
}

.eg-card[role='link']:hover,
.eg-card[role='link']:focus-visible {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);
  outline: none;
  border-color: #b32025;
}

.eg-card__icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #b32025;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
}

.eg-card__body {
  flex: 1 1;
  min-width: 0;
}

.eg-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.eg-card__title {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: var(--eg-text, #0f172a);
  line-height: 1.3;
}

.eg-card__status {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  background: #fdf3f3;
  color: #b32025;
  border-radius: 999px;
  padding: 2px 7px;
  white-space: nowrap;
}

.eg-card__subtitle {
  margin: 4px 0 0;
  font-size: 11.5px;
  color: var(--eg-text-muted, #64748b);
  line-height: 1.35;
}

.eg-card__progress {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 8px;
}

.eg-card__progress-track {
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.eg-card__progress-bar {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #b32025, #d4282e);
}

.eg-card__progress-label {
  font-size: 11px;
  font-weight: 700;
  color: var(--eg-text-muted, #64748b);
}

.eg-card__action {
  margin-top: 8px;
  border: none;
  background: #b32025;
  color: #fff;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.eg-card__action:hover,
.eg-card__action:focus-visible {
  background: #8f1a1e;
  outline: none;
}

.edugenie-root[data-theme='dark'] .eg-card {
  background: #1e293b;
  border-color: #334155;
}

.edugenie-root[data-theme='dark'] .eg-card__status {
  background: rgba(179, 32, 37, 0.2);
}

.edugenie-root[data-theme='dark'] .eg-card__progress-track {
  background: #334155;
}
`, "",{"version":3,"sources":["webpack://./src/components/edugenie/richCards.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,4CAA4C;EAC5C,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".eg-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n  width: min(100%, 300px);\n}\n\n.eg-card {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  background: var(--eg-bg, #fff);\n  border: 1px solid var(--eg-border, #e2e8f0);\n  border-radius: 14px;\n  padding: 10px;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.eg-card[role='link'] {\n  cursor: pointer;\n}\n\n.eg-card[role='link']:hover,\n.eg-card[role='link']:focus-visible {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);\n  outline: none;\n  border-color: #b32025;\n}\n\n.eg-card__icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: #b32025;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 14px;\n}\n\n.eg-card__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.eg-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.eg-card__title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--eg-text, #0f172a);\n  line-height: 1.3;\n}\n\n.eg-card__status {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  background: #fdf3f3;\n  color: #b32025;\n  border-radius: 999px;\n  padding: 2px 7px;\n  white-space: nowrap;\n}\n\n.eg-card__subtitle {\n  margin: 4px 0 0;\n  font-size: 11.5px;\n  color: var(--eg-text-muted, #64748b);\n  line-height: 1.35;\n}\n\n.eg-card__progress {\n  margin-top: 8px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 8px;\n}\n\n.eg-card__progress-track {\n  height: 6px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.eg-card__progress-bar {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #b32025, #d4282e);\n}\n\n.eg-card__progress-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--eg-text-muted, #64748b);\n}\n\n.eg-card__action {\n  margin-top: 8px;\n  border: none;\n  background: #b32025;\n  color: #fff;\n  border-radius: 8px;\n  padding: 5px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.eg-card__action:hover,\n.eg-card__action:focus-visible {\n  background: #8f1a1e;\n  outline: none;\n}\n\n.edugenie-root[data-theme='dark'] .eg-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.edugenie-root[data-theme='dark'] .eg-card__status {\n  background: rgba(179, 32, 37, 0.2);\n}\n\n.edugenie-root[data-theme='dark'] .eg-card__progress-track {\n  background: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
